module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/flea_infobanner01.f07b840.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/product_info/flea_infobanner01.png
// module id = i+un
// module chunks = 0